export default function repeatableBookingFactory(moment) {
    var factory = this;

    //defaults
    factory.selectedWeekRange = []; // from parent booking
    factory.selectedWeekDays = []; //from parent booking

    factory.weekdays = [
        {
            dayname: "Mandag",
            weekIndex: 0,
            active: false,
        },
        {
            dayname: "Tirsdag",
            weekIndex: 1,
            active: false,
        },
        {
            dayname: "Onsdag",
            weekIndex: 2,
            active: false,
        },
        {
            dayname: "Torsdag",
            weekIndex: 3,
            active: false,
        },
        {
            dayname: "Fredag",
            weekIndex: 4,
            active: false,
        },
        {
            dayname: "Lørdag",
            weekIndex: 5,
            active: false,
        },
        {
            dayname: "Søndag",
            weekIndex: 6,
            active: false,
        },
    ];

    factory.weekRanges = [
        {
            rangeName: "1 måned frem",
            amount: 1,
            measure: "month",
            active: true,
        },
        {
            rangeName: "3 måneder frem",
            amount: 3,
            measure: "month",
            active: false,
        },
        {
            rangeName: "6 måneder frem",
            amount: 6,
            measure: "month",
            active: false,
        },
        {
            rangeName: "1 år frem",
            amount: 1,
            measure: "year",
            active: false,
        },
    ];

    /**
     * for each selected weekday - Find all ocurring tuesdays(example)
     * from today until given time
     * @param {ob} weekday    [description]j
     * @param {obj} weeksRange [description]
     */
    factory.addOccurringWeekday = function (
        weekday,
        weeksRange,
        bookingOrigin
    ) {
        var ocurringWeekDayInRange = [];

        var bookingDateMoment = moment(bookingOrigin.BookingStart);

        // Update weekRange EndDate
        weeksRange.rangeEndDate = moment(bookingOrigin.BookingStart).add(
            weeksRange.amount,
            weeksRange.measure
        );

        //console.log(bookingOrigin);

        var date = bookingDateMoment.date(),
            offset = weekday.weekIndex + 7 - bookingDateMoment.weekday(), // days till next Monday
            duration = moment.duration(
                weeksRange.rangeEndDate.diff(bookingDateMoment)
            ),
            weeks = duration.asWeeks();

        // console.log(bookingDateMoment);
        // console.log(date);

        // console.log('weekday.weekIndex : ' + weekday.weekIndex);
        // console.log('offset : ' + offset);
        // console.log('duration : ' + duration);
        // console.log('weeks : ' + weeks);

        for (var i = 0; i < Math.floor(weeks); i++) {
            var daysToAdd = date + offset + 7 * i;

            // console.log( moment(bookingOrigin.BookingStart).format('DD-MM-YYYY') );

            // console.log(bookingDateMoment.date() );

            // console.log('daysToAdd : ' + daysToAdd);

            ocurringWeekDayInRange.push(
                moment(bookingOrigin.BookingStart).date(daysToAdd)
            );
        }

        //console.log(ocurringWeekDayInRange);

        return ocurringWeekDayInRange;
    };

    /**
     * prepare an array of objects that contains all calculated repeatables
     * @param  {[array]} weeksRange [description]
     * Requires factory.selectedWeekDays
     * @return {[type]}            [description]
     */
    factory.prepareRepeatableSearchObject = function (
        selectedWeekRange,
        selectedWeekDays,
        bookingOrigin
    ) {
        var aRepeatables = [];

        angular.forEach(selectedWeekDays, function (oWeekday) {
            if (oWeekday.active) {
                aRepeatables.push({
                    oWeekday: oWeekday,
                    futureWeekdaysInRange: factory.addOccurringWeekday(
                        oWeekday,
                        selectedWeekRange,
                        bookingOrigin
                    ),
                    selectedWeekRange: selectedWeekRange,
                });
            }
        });

        return aRepeatables;
    };

    /**
     * set Same WeekDay Checkmark As Booking-Origin
     * Used In user Options (weekday checkboxes)
     */
    factory.setSameAsBookingOriginWeekday = function (booking, weekdays) {
        var weekIndex = moment(booking.BookingStart).weekday();

        weekdays[weekIndex].active = true;

        return weekdays[weekIndex];
    };

    return factory;
}
